module.exports = __webpack_public_path__ + "static/media/Console Categorie.0b4e3b82.png";